import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-without-nav-bar',
  templateUrl: './without-nav-bar.component.html'
})
export class WithoutNavBarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
